import { useMutation } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import type { TSaveClaimAttachmentAuditEntryDto } from '../../@types/rcm';
import { makeAPIRequestV2 } from '../../utils/api';
import { endpoints } from '../endpoints';

export const useSaveAttachmentAudit = () => {
  const user = useSelector((state: any) => state.login.user);

  return useMutation(
    (saveAuditEntryBody: TSaveClaimAttachmentAuditEntryDto) => {
      return makeAPIRequestV2(
        `/${endpoints.saveAttachmentAudit}`,
        {
          data: saveAuditEntryBody,
          headers: {
            Org: user.primaryOrganizationId,
            Practice: user.primaryPracticeId,
          },
        },
        'POST',
      );
    },
  );
};
